
import Identity from '@/components/common/IdentityForm.vue'

export default {
  name: 'IdentityPage',
  components: {
    Identity,
  },
  layout: 'centered-half-layout',
}
